import type { TranscriptTranslationFormState } from "../../shared/types"

export const DEFAULT_STATE: TranscriptTranslationFormState = {
  transcript_translation_enabled: false,
  translate_to_language: null,
  translate_from_languages: []
}
